<template>
  <div class="flex flex-col space-y-6 p-6 min-h-screen">
    <!-- Section KPI -->
    <div v-if="kpiStats" class="space-y-6">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-6">
        <div class="bg-white rounded-lg shadow-sm p-4 border border-[#ec4400] flex items-stretch">
          <div class="flex-shrink-0 flex items-center justify-center w-16 rounded-l-lg">
            <img src="@/assets/vehiculein_N.png" alt="Icône" class="h-20 w-auto object-contain" />
          </div>
          <div class="flex-1 flex flex-col justify-center items-center p-2">
            <h5 class="text-gray-600 text-xs font-medium text-center uppercase mb-1">Staff présents</h5>
            <p class="text-3xl font-bold" style="color: #ec4400">{{ kpiStats.ongoingVehicles }}</p>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-sm p-4 border border-[#ec4400] flex items-stretch">
          <div class="flex-shrink-0 flex items-center justify-center w-16 rounded-l-lg">
            <img src="@/assets/heurepointe_N.png" alt="Icône" class="h-20 w-auto object-contain" />
          </div>
          <div class="flex-1 flex flex-col justify-center items-center p-2">
            <h5 class="text-gray-600 text-xs font-medium text-center uppercase mb-1">Heure d'affluence</h5>
            <p class="text-3xl font-bold" style="color: #ec4400">{{ kpiStats.peakHour || "N/A" }}</p>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-sm p-4 border border-[#ec4400] flex items-stretch">
          <div class="flex-shrink-0 flex items-center justify-center w-16 rounded-l-lg">
            <img src="@/assets/duree_N.png" alt="Icône" class="h-20 w-auto object-contain" />
          </div>
          <div class="flex-1 flex flex-col justify-center items-center p-2">
            <h5 class="text-gray-600 text-xs font-medium text-center uppercase mb-1">Durée moyenne</h5>
            <p class="text-3xl font-bold" style="color: #ec4400">{{ kpiStats.averageDuration }}</p>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-sm p-4 border border-[#ec4400] flex items-stretch">
          <div class="flex-shrink-0 flex items-center justify-center w-16 rounded-l-lg">
            <img src="@/assets/entrerpise_N.png" alt="Icône" class="h-20 w-auto object-contain" />
          </div>
          <div class="flex-1 flex flex-col justify-center items-center p-2">
            <h5 class="text-gray-600 text-xs font-medium text-center uppercase mb-1">Total flotte</h5>
            <p class="text-3xl font-bold" style="color: #ec4400">{{ kpiStats.totalManagedVehicles }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Filters -->
    <div class="flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0 sm:space-x-3">
      <div class="flex items-center space-x-3 w-full flex-wrap sm:flex-nowrap">
        <input type="text" v-model="searchQuery" placeholder="Rechercher par immatriculation, marque, badge" class="border bg-white border-[#ec4400] rounded-lg py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-orange-200 w-full sm:w-2/5"/>
        <input type="date" v-model="startDate" placeholder="Date Début" class="border bg-white border-[#ec4400] rounded-lg py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-orange-200 w-1/2 sm:w-1/5"/>
        <input type="date" v-model="endDate" placeholder="Date Fin" class="border bg-white border-[#ec4400] rounded-lg py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-orange-200 w-1/2 sm:w-1/5"/>
        <button v-if="startDate || endDate || searchQuery" @click="clearFilters" class="bg-gray-200 text-gray-700 px-3 py-2 rounded-lg text-sm hover:bg-gray-300 transition-colors duration-200 flex-shrink-0">Effacer</button>
      </div>
      <button @click="downloadPdf" class="text-white px-4 py-2 rounded-2xl text-sm hover:bg-white transition-colors duration-200 flex items-center space-x-2 w-full sm:w-auto flex-grow sm:flex-grow-0">
        <i class="fas fa fa-download text-lg text-[#ec4400]"></i>
      </button>
    </div>
    <!-- Table -->
    <div class="bg-white shadow-sm rounded-lg border border-[#ec4400] overflow-hidden">
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm text-left text-gray-700">
          <thead class="bg-gray-50 text-xs uppercase font-semibold text-gray-500">
            <tr>
              <th class="px-3 py-2 text-xs">Agent Entrée</th>
              <th class="px-3 py-2 text-xs">Agent Sortie</th>
              <th class="px-3 py-2 text-xs">Immatriculation</th>
              <th class="px-3 py-2 text-xs">Badge</th>
              <th class="px-3 py-2 text-xs">Marque</th>
              <th class="px-3 py-2 text-xs">Type</th>
              <th class="px-3 py-2 text-xs">Heure Entrée</th>
              <th class="px-3 py-2 text-xs">Heure Sortie</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in transformedLogs" :key="log.id" class="border-b border-gray-100 hover:bg-gray-50">
              <td class="px-3 py-2">{{ log.agent_entrance_name || "—" }}</td>
              <td class="px-3 py-2">{{ log.agent_departure_name || "—" }}</td>
              <td class="px-3 py-2 flex items-center">
                <span v-if="log.isPresent" class="h-2 w-2 bg-green-500 rounded-full mr-2"></span>
                {{ log.license_plate || "—" }}
              </td>
              <td class="px-3 py-2">{{ log.badge_number || "—" }}</td>
              <td class="px-3 py-2">{{ log.brand || "—" }}</td>
              <td class="px-3 py-2">{{ log.vehicle_type || "—" }}</td>
              <td class="px-3 py-2">{{ formatDateTime(log.entrance_time) }}</td>
              <td class="px-3 py-2">{{ formatDateTime(log.exit_time) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Pagination -->
      <div class="flex justify-between items-center p-4 border-t border-gray-200">
        <button class="px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed" :disabled="currentPage === 1" @click="prevPage">
          <img src="@/assets/flecheap.png" alt="Flèche page précédente" class="h-5 w-auto object-contain"/>
        </button>
        <span class="text-sm text-gray-600">Page {{ currentPage }} / {{ totalPages }}</span>
        <button class="px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed" :disabled="currentPage === totalPages || totalPages === 0" @click="nextPage">
          <img src="@/assets/flecheav.png" alt="Flèche page suivante" class="h-5 w-auto object-contain"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watch } from "vue";
import html2pdf from "html2pdf.js";
import apiFetch from '@/apiClient';

const API_URL = process.env.VUE_APP_API_URL;

export default {
  name: "StaffVehiclesDashboard",
    setup() {
      const logs = ref({ data: [], totalCount: 0 });
      const searchQuery = ref("");
      const currentPage = ref(1);
      const itemsPerPage = 15;
      const sortColumn = ref("entrance_time");
      const sortDirection = ref("desc");
      
      const startDate = ref('');
      const endDate = ref('');
      
      const kpiStats = ref(null);
      const errorMessage = ref("");
      const usersMap = ref({});

    const getAuthHeaders = () => ({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
    });

    const fetchUsersMap = async () => {
      try {
        const usersList = await apiFetch('/auth/users');
        const map = {};
        usersList.forEach(user => { if (user.id && user.username) map[user.id] = user.username; });
        usersMap.value = map;
      } catch (err) {
        console.error("Erreur fetch Users Map:", err);
        errorMessage.value = `Impossible de charger la liste des agents.`;
      }
    };

    const fetchLogs = async () => {
      try {
        errorMessage.value = "";
        const params = new URLSearchParams({
          page: currentPage.value,
          limit: itemsPerPage,
          sortColumn: sortColumn.value,
          sortDirection: sortDirection.value,
          sortByPresence: true, // Add this new parameter
        });

        if (searchQuery.value) params.append("search", searchQuery.value);
        if (startDate.value) params.append("startDate", startDate.value);
        if (endDate.value) params.append("endDate", endDate.value);

        const result = await apiFetch(`/fleet/logs?${params.toString()}`);
        // Store response into the `logs` ref used elsewhere in this component
        logs.value.data = result.data || [];
        logs.value.totalCount = result.total || result.totalCount || 0;
      } catch (err) {
        console.error("Erreur fetch logs:", err);
        errorMessage.value = `Impossible de charger les journaux.`;
      }
    };

    const fetchKpiStats = async () => {
      try {
        const response = await fetch(`${API_URL}/fleet/dashboard-stats`, { headers: getAuthHeaders() });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || "Erreur réseau lors de la récupération des KPI");
        }
        kpiStats.value = await response.json();
      } catch (err) {
        console.error("Erreur fetch KPI:", err);
        errorMessage.value = `Erreur lors du chargement des KPI: ${err.message}`;
      }
    };

    const transformedLogs = computed(() => {
      if (!logs.value.data.length) return [];

      return logs.value.data.map((log) => ({
        ...log,
        agent_entrance_name: usersMap.value[log.user_entrance_id] || log.user_entrance_id || "—",
        agent_departure_name: usersMap.value[log.user_departure_id] || log.user_departure_id || "—",
        isPresent: !log.exit_time, // Keep this for the green dot
      }));
    });

    const totalPages = computed(() => Math.ceil(logs.value.totalCount / itemsPerPage));

    onMounted(() => {
      fetchUsersMap();
      fetchLogs();
      fetchKpiStats();
    });

    watch([searchQuery, startDate, endDate], () => {
      currentPage.value = 1;
      fetchLogs();
    });
    watch(currentPage, fetchLogs);

    const prevPage = () => { if (currentPage.value > 1) currentPage.value--; };
    const nextPage = () => { if (currentPage.value < totalPages.value) currentPage.value++; };

    const clearFilters = () => {
      startDate.value = "";
      endDate.value = "";
      searchQuery.value = "";
      currentPage.value = 1;
      fetchLogs();
    };

    const formatDateTime = (isoString) => {
        if (!isoString) return '—';
        const date = new Date(isoString);
        return date.toLocaleString('fr-FR', { year: '2-digit', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
    };

    const downloadPdf = async () => {
      const params = new URLSearchParams({
          sortColumn: sortColumn.value,
          sortDirection: sortDirection.value,
          limit: "99999",
          page: "1",
          ...(searchQuery.value && { search: searchQuery.value }),
          ...(startDate.value && { startDate: startDate.value }),
          ...(endDate.value && { endDate: endDate.value }),
      });
      
      try {
        const response = await fetch(`${API_URL}/fleet/logs?${params.toString()}`, { headers: getAuthHeaders() });
        if (!response.ok) throw new Error('Failed to fetch data for PDF');
        
        const result = await response.json();
        const logsToPrint = result.data.map(l => ({
            ...l,
            agent_entrance_name: usersMap.value[l.user_entrance_id] || l.user_entrance_id || "—",
            agent_departure_name: usersMap.value[l.user_departure_id] || l.user_departure_id || "—",
        })) || [];

        if (logsToPrint.length === 0) {
          alert("Aucun log à télécharger selon les filtres actuels.");
          return;
        }

        let pdfHtml = `
          <style>
            table { width: 100%; border-collapse: collapse; margin-top: 15px; }
            th, td { border: 1px solid #ccc; padding: 6px; text-align: left; font-size: 8px; }
            th { background-color: #f2f2f2; color: #ec4400; font-weight: bold; }
            h2 { color: #ec4400; text-align: center; font-size: 16px; }
          </style>
          <h2>Rapport des Entrées/Sorties Staff</h2>
          <table>
            <thead>
              <tr>
                <th>Agent Entrée</th>
                <th>Agent Sortie</th>
                <th>Immatriculation</th>
                <th>Marque</th>
                <th>Heure Entrée</th>
                <th>Heure Sortie</th>
              </tr>
            </thead>
            <tbody>
              ${logsToPrint.map(l => `
                <tr>
                  <td>${l.agent_entrance_name}</td>
                  <td>${l.agent_departure_name}</td>
                  <td>${l.license_plate}</td>
                  <td>${l.brand || "—"}</td>
                  <td>${formatDateTime(l.entrance_time)}</td>
                  <td>${formatDateTime(l.exit_time)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        `;
        html2pdf().set({ margin: 10, filename: `rapport_staff_${new Date().toISOString().slice(0, 10)}.pdf`, jsPDF: { orientation: 'landscape' } }).from(pdfHtml).save();
      } catch (err) {
        alert(`Erreur lors de la génération du PDF: ${err.message}`);
      }
    };

    return {
      searchQuery,
      transformedLogs,
      currentPage,
      totalPages,
      prevPage,
      nextPage,
      kpiStats,
      startDate,
      endDate,
      clearFilters,
      downloadPdf,
      errorMessage,
      formatDateTime,
    };
  },
};
</script>